export default __webpack_public_path__ + "static/photo-26-e96ded592615bae7b08ad4d1db9cbfd9.jpg";